import styled from "styled-components";
import { modalProps } from "../../../../Component/Interface/Modal";
import {
  CenterView,
  Icon,
  RowView,
} from "../../../../Component/style/common_style";
import { amountFormat } from "../../../../Component/tool/Tools";
import moment from "moment";
import { useEffect, useState } from "react";
import api from "../../../../Component/axios_Interceptor/api";
import url from "../../../../Component/server";
import { StoreInfo } from "../../../../Component/Interface/Store";
import { useParams } from "react-router-dom";
import axios from "axios";
import { live_info_type } from "../../../User/Live/Live";

interface SendPaymentModalProps extends modalProps {
  sendType: string;
  store_info: StoreInfo;
}

const SendPaymentModal = ({
  visible,
  handleModal,
  sendType,
}: SendPaymentModalProps) => {
  const closeModal = () => {
    handleModal();
  };

  const stopPropagation = (e: React.MouseEvent) => {
    e.stopPropagation();
  };
  const { seq } = useParams();
  const [useCoin, setUseCoin] = useState(0);
  const [myCoin, setMyCoin] = useState(60000);
  const [liveInfo, setLiveInfo] = useState<live_info_type>();
  const [alimtalk_count, set_Alimtalk_Count] = useState(0);
  const [order_count, set_Order_Count] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const get_live_info = () => {
    axios
      .get(url.Communication_url.get_live_info, {
        params: {
          seq: seq,
        },
      })
      .then(function (response) {
        setLiveInfo(response.data);
      })
      .catch(function (error) {
        // console.log("get-live-info error", error);
      });
  };

  const stockCoin = async () => {
    const res = await api.get(url.Communication_url.stock_coin);
    setMyCoin(res.data.coin);
  };

  // 알림톡 보낼 유저 수 체크
  const alimtalk_follow_check = async () => {
    try {
      setIsLoading(true);
      const res = await api.get(url.Communication_url.alimtalk_follow_check);
      set_Alimtalk_Count(res.data);
      setUseCoin(Coin_Account(res.data));
    } catch (error) {
      console.log(error);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 500);
    }
  };

  // 알림톡 완료된 후 테스트
  const send_alimtalk = async () => {
    try {
      const res = await api.post(url.Communication_url.send_alimtalk, {
        live_seq: seq,
        live_title: liveInfo?.live_title,
        coin: useCoin,
      });
      closeModal();
    } catch (error) {
      console.log(error);
    }
  };

  // 정산서 보낼 유저 수 체크
  const live_order_count = async () => {
    try {
      const res = await api.get(url.Communication_url.live_order_count, {
        params: {
          live_seq: seq,
        },
      });
      set_Order_Count(res.data.order_count);
      setUseCoin(Coin_Account(res.data.order_count));
    } catch (error) {
      console.log(error);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 500);
    }
  };

  // 정산서 보내기
  const send_statement = async () => {
    try {
      const res = await api.post(url.Communication_url.send_statement, {
        live_seq: seq,
        order_count: order_count,
        coin: useCoin,
      });
      closeModal();
    } catch (error) {
      console.log(error);
    }
  };

  const Coin_Account = (count: number) => {
    return Math.ceil(count / 5);
  };

  useEffect(() => {
    get_live_info();
    stockCoin();
    sendType === "알림톡" ? alimtalk_follow_check() : live_order_count();
  }, [sendType]);

  return (
    <Container style={visible ? {} : { display: "none" }} onClick={closeModal}>
      <ModalBox onClick={stopPropagation}>
        <Title>
          <RowView>
            <div>{sendType} 보내기</div>
            <Icon
              className="btn"
              onClick={handleModal}
              src={require("../../../../Image/ic_closeX.png")}
            />
          </RowView>
        </Title>
        {isLoading ? (
          <Loading>
            <div className="loading" />
          </Loading>
        ) : (
          <ContentDiv>
            <RowView style={{ width: "100%" }}>
              <RowView style={{ gap: 10 }}>
                <div>대상자</div>
                <div className="black">
                  {amountFormat(
                    sendType === "알림톡" ? alimtalk_count : order_count
                  )}
                  명
                </div>
              </RowView>
              <div className="black">
                {Coin_Account(
                  sendType === "알림톡" ? alimtalk_count : order_count
                )}
                C
              </div>
            </RowView>
            <Bar />
            <RowView style={{ width: "100%" }}>
              <div className="black">총 결제 코인</div>
              <div className="usecoin">{amountFormat(useCoin)}C</div>
            </RowView>
            <div className="mycoin">보유 코인 : {amountFormat(myCoin)}C</div>
          </ContentDiv>
        )}
        <BtnDiv>
          <ApplyBtn
            disabled={myCoin < useCoin}
            style={{
              cursor: myCoin >= useCoin ? "pointer" : "not-allowed",
              opacity: myCoin >= useCoin ? 1 : 0.5,
            }}
            onClick={() => {
              if (myCoin >= useCoin) {
                sendType === "알림톡" ? send_alimtalk() : send_statement();
              }
            }}
          >
            결제하기
          </ApplyBtn>
        </BtnDiv>
        {myCoin < useCoin && (
          <RedText>보유 코인이 부족합니다. 충전 후 다시 이용해주세요.</RedText>
        )}
      </ModalBox>
    </Container>
  );
};
export default SendPaymentModal;

const Container = styled.div`
  z-index: 99;
  background-color: #00000085;
  position: fixed;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
`;

const ModalBox = styled.div`
  box-sizing: border-box;
  width: 95%;
  max-width: 25rem;
  margin: auto 0rem;
  background-color: white;
  color: #2d2d2d;
  border-radius: 8px;
  overflow: hidden;
  padding: 24px;
  div.info {
    color: #8e8e8e;
    font-size: 14px;
    text-align: center;
    line-height: 19px;
  }
`;

const Title = styled.div`
  align-items: center;
  justify-content: flex-start;
  font-size: 20px;
  font-family: var(--font-Pretendard-SemiBold);
  margin-top: 5px;
`;

const ContentDiv = styled.div`
  padding: 20px 8px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  font-size: 16px;
  font-family: var(--font-Pretendard-Regular);
  flex-direction: column;
  text-align: center;
  color: #8e8e8e;
  gap: 10px;
  div.black {
    color: black;
    font-family: var(--font-Pretendard-Medium);
  }
  div.usecoin {
    color: red;
    font-family: var(--font-Pretendard-SemiBold);
    font-size: 20px;
  }
  div.mycoin {
    font-size: 14px;
    color: #8e8e8e;
    align-self: flex-end;
    margin-bottom: 5px;
  }
`;

const BtnDiv = styled(RowView)`
  position: relative;
  width: 100%;
`;

const Btn = styled.button`
  border-radius: 8px;
  height: 48px;
  flex: 1;
  align-items: center;
  justify-content: center;
  display: flex;
  font-size: 16px;
  font-family: var(--font-Pretendard-SemiBold);
  cursor: pointer;
  border: none;
`;

const ApplyBtn = styled(Btn)<{ disabled?: boolean }>`
  background: ${({ disabled }) =>
    disabled
      ? "linear-gradient(135deg, #f5f5f5, #f5f5f5)"
      : "linear-gradient(135deg, #7955f0, #3209b9)"};
  color: ${({ disabled }) => (disabled ? "#000000" : "white")};
`;

const Bar = styled.div`
  width: 100%;
  height: 1px;
  background-color: #e8e8e8;
  margin: 5px 0px;
`;

const RedText = styled.div`
  font-size: 14px;
  color: red;
  text-align: center;
  margin-top: 10px;
`;

const Loading = styled(CenterView)`
  padding: 50px 0px 50px 0px;
  color: #858585;
  div.loading {
    width: 30px;
    height: 30px;
    box-sizing: border-box;
    border: 3px solid #7955f0;
    border-top-color: #ffffff;
    border-radius: 100%;
    animation: spin 1s ease-in-out infinite;
  }
  @keyframes spin {
    100% {
      transform: rotate(360deg);
    }
  }
`;
